module.exports = __webpack_public_path__ + "static/media/bnr_minatoce35ec5ef918c02c34a9bb22d9b1b382.webp";